import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';
import { SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';

import { FirmWallets } from './firmWallets';
import { muiStyles } from './firmWalletsStyles';

export interface IFirmWalletsProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    assetPair: SecurityCurrencyAssetPair;
}

export default withStyles(muiStyles)(FirmWallets);